
<template>
  <div class="business">
    <component :is="$store.state.device"></component>
  </div>
</template>

<script>
import m from './device/m.vue'
import pc from './device/pc.vue'

export default {
  name: 'business',

  components: {
    pc,
    m
  }
}
</script>
